import { Id, isSuccess, useLaravelCrudEntity } from "@dgs/core";
import { useTranslation } from "react-i18next";
import { clippingsService } from "../../shared/api/clippingsService";
import { companyService } from "../../shared/api/companyService";
import { contactAttributeKeys } from "../../shared/api/contactAttributeService";
import { contactFilterService } from "../../shared/api/contactFilterService";
import { dataFieldService } from "../../shared/api/dataFieldService";

export const useCompany = () => {
	const { t } = useTranslation();

	const { createEntity, updateEntity, deleteEntity } = useLaravelCrudEntity(
		companyService,
		{
			entityName: t("Company"),
			messages: {
				create: t("Company was saved."),
				update: t("Company was saved."),
				delete: t("Company was deleted."),
			},
		},
		[
			contactAttributeKeys.index,
			dataFieldService.indexAllKey,
			contactFilterService.indexKey,
			clippingsService.indexKey,
		],
	);

	const showCompany = async (id: Id) => {
		const response = await companyService.show(id);
		if (isSuccess(response)) {
			return response.data.data;
		}
		return false;
	};

	return {
		showCompany,
		createCompany: createEntity,
		updateCompany: updateEntity,
		deleteCompany: deleteEntity,
	};
};
